export const PercentComparator = (valueA, valueB) => {
    const extractPercentage = (val) => {
        if (!val) return null;
 
        // Strip HTML tags (like <p>, <span>, etc.)
        const plainText = val.replace(/<[^>]*>/g, '').trim().toLowerCase();
 
        // Handle edge cases
        if (["na", "-", "failed"].includes(plainText)) return null;
 
        // Extract number before "%"
        const match = plainText.match(/(\d+(\.\d+)?)\s*%/i);
        return match ? parseFloat(match[1]) : null;
    };
 
    const percentA = extractPercentage(valueA);
    const percentB = extractPercentage(valueB);
 
    if (percentA !== null && percentB !== null) return percentA - percentB;
    if (percentA !== null) return 1;
    if (percentB !== null) return -1;
    return 0;
};